import { EligibilityData } from '@/modules/Users/pages/Patient/components/RegisterPatient/RegisterPatient.types'

class EligibilityMapper {
  toDomain(data): EligibilityData {
    return {
      eligible: data?.elegivel,
      denialMessage: data?.mensagemGlosa,
      denialCode: data?.codigoGlosa,
      externalGuideValidity: data?.validadeGuiaExterna,
      patient: {
        name: data?.nomePaciente,
        cardNumber: data?.carteiraConvenio,
        ansRecord: data?.registroAns,
      },
    }
  }
}

export default new EligibilityMapper()
